<template>
    <div class="media align-items-center">
        <app-avatar :title="rowData.name"
                    avatar-class="avatars-w-50"
                    :img="$optional(rowData, 'image', 'path')"
                    :alt-text="rowData.name"/>
        <div class="media-body ml-3">
            <a v-if="rowData.name" :href="`${urlGenerator(this.apiUrl.PRODUCTS)}/${rowData.slug}/edit`">{{ rowData.name }}</a><br>
            <a href="#" class="text-muted" target="blank" v-if="rowData.brand">
                Brand: {{ $optional(rowData.brand, 'name') }}
            </a>
        </div>
    </div>
</template>

<script>
    import {urlGenerator} from "../../../Helpers/AxiosHelper";

    export default {
        name: "ProductMedia",
        props: {
            value: {},
            rowData: {},
            index: {},
        },
        data() {
            return {
                urlGenerator
            }
        }
    }
</script>

<style scoped>

</style>